<div data-bb="qrCode" [innerHTML]="qrCode()" [attr.aria-label]="ariaLabel()" role="img"></div>
